(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("3d-tiles-point-cloud", [], factory);
	else if(typeof exports === 'object')
		exports["3d-tiles-point-cloud"] = factory();
	else
		root["3d-tiles-point-cloud"] = factory();
})(self, function() {
return 